import { LocalStorageAdapter } from './adapter/adapters';

enum StorageKey {
  LOCALE = 'game/locale',
  COOKIE_CONSENT = 'game/cookie-consent',
  INSTALL_PROMPT = 'game/install-prompt',
  TEMP_ID = 'game/temp-id',
}

const storage = new LocalStorageAdapter();

export default class MainStorage {
  static saveLocale(locale: string): void {
    storage.setItem(StorageKey.LOCALE, locale);
  }

  static getLocale(): string | null {
    return storage.getItem(StorageKey.LOCALE);
  }

  static saveCookieConsent(consent: boolean): void {
    storage.setItem(StorageKey.COOKIE_CONSENT, consent);
  }

  static getCookieConsent(): boolean | null {
    return storage.getItem(StorageKey.COOKIE_CONSENT);
  }

  static saveInstallPrompt(outcome: string): void {
    storage.setItem(StorageKey.INSTALL_PROMPT, outcome);
  }

  static getInstallPrompt(): string | null {
    return storage.getItem(StorageKey.INSTALL_PROMPT);
  }

  static saveTempId(tempId: string): void {
    storage.setItem(StorageKey.TEMP_ID, tempId);
  }

  static getTempId(): string | null {
    return storage.getItem(StorageKey.TEMP_ID);
  }
}
